module.exports = __webpack_public_path__ + "img/vue.0690f93a.svg";